import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const request: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/location-groups',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/location-groups' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};
const response: Json = {
    title: 'RESPONSE',
    json: {
        "totalCount": 1,
        "totalPages": 1,
        "pageNumber": 1,
        "pageSize": 100,
        "results": [
            {
                "id": 1,
                "name": "Main",
                "active": true,
                "readOnly": false,
                "class": {
                    "id": 1,
                    "name": "None"
                }
            },
        ]
    },
};

const queryParameters: Attribute[] = [
    {
        name: 'pageNumber',
        type: 'integer',
        optional: true,
        description: 'The current page of the results.'
    },
    {
        name: 'pageSize',
        type: 'integer',
        optional: true,
        description: 'The number of returned results per page. (Default 100)'
    },
    {
        name: 'name',
        type: 'string',
        optional: true,
        description: 'The location group name.',
    },
    {
        name: 'active',
        type: 'boolean',
        optional: true,
        description: 'The active status of the location groups.',
    },
];

const attributes: Attribute[] = [];

const data: RequestDefinitionData = {
    id: 'search-location-group',
    title: 'Search for location groups',
    description: 'Searches for location groups.',
    endpoint: {
        verb: 'GET',
        path: '/location-groups',
        tooltip: 'Search for location groups',
    },
    attributes: attributes,
    requestObject: request,
    responseObject: response,
    queryParameters: queryParameters,
}

export default data;
